<template>
  <div class="component-wrapper row g-0 ">
    <div class="col-md-6 col-12 d-md-none ">
      <div :style="getBackgroundStyle(imageUrl)" class="mock-image">
      </div>
    </div>
    <div class="col-md-6 col-12 d-flex align-items-center content-wrapper">
      <div>
        <div class="title">{{ title }}</div>
        <div class="subtitle">{{ subtitle }}</div>
        <div class="description">{{ description }}</div>
        <div class="col-md-4 align-items-center ">
          <a href="https://earthandpeople.bg/" target="_blank">
            <MainButton :button-text="$t('about-hotel-button')" :icon="'arrow-forward'" :size="'medium'"
                        :theme="'solid-blue'"/>
          </a>

        </div>
      </div>
    </div>
    <div class="col-md-6 col-12 d-none d-md-block ">
      <div :style="getBackgroundStyle(imageUrl)" class="mock-image">
      </div>
    </div>
  </div>
</template>

<script>

import MainButton from "@/components/Common/Buttons/MainButton.vue";

export default {
  name: 'AboutHotelComponent',
  components: {MainButton},
  props: {
    title: {
      type: String,
    },
    subtitle: {
      type: String,
    },
    description: {
      type: String,
    },
    imageUrl: {
      type: String,
    },
    buttonPlaceholder: {
      type: String,
    },
  },
  methods: {
    getBackgroundStyle(imageUrl) {
      return {
        backgroundImage: `url(${imageUrl})`,

      };
    },
  },
};
</script>

<style lang="scss" scoped>
.component-wrapper {
  overflow: hidden;
  color: $color-brown;
  background: $color-white;
  border-radius: 30px;

  .content-wrapper {
    padding: 20px;
    background: $color-light-brown;
  }

  .title, .subtitle {
    font-family: $font-bold;
    text-transform: uppercase;
  }

  .title {
    font-size: $title-h4;
    line-height: $title-h4;

  }

  .subtitle {
    font-size: $subtitle-1;

  }

  .description {
    margin: $spacing-5 0;
    font-size: $paragraph-1;
    line-height: $paragraph-1-lh;
  }

  .button-placeholder {
    font-size: 25px;
    line-height: 25px;
    width: 10%;
    margin-left: 20px;
  }

  .mock-image {

    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    height: 400px;
    width: 100%;

  }
}

@media screen and (min-width: 768px) {
  .component-wrapper {
    border-radius: 50px;

    .content-wrapper {
      padding: 0px 80px;
    }

    .subtitle {
      font-size: $title-h5;

    }

    .title {
      font-size: $title-h2;
      line-height: 40px;
    }

    .mock-image {
      height: 550px;
    }
  }

}
</style>
